import { Injectable } from '@angular/core';
import { AlertController, ModalController, NavController } from '@ionic/angular';
import { WalletInterrogateSuccessPageComponent } from '@symphony-solo/pages/loyalty/wallet-interrogate-success/src/lib/wallet-interrogate-success/wallet-interrogate-success-page.component';
import { CHECKOUT_ORDER, LOGIN, SIGNUP } from '@symphony-solo/shared/utils/src';

@Injectable()
export class AlertService {
  constructor(private alertController: AlertController, private modalCtrl: ModalController, private navController: NavController) {}

  public async presentAlert(
    header: string,
    message: string,
    buttons: any[],
    isBackDropDismiss?: boolean,
    customClass?: string,
    allowMultiPopup?: boolean
  ): Promise<any> {
    if (!allowMultiPopup) {
      const res = await this.alertController.getTop();
      if (res) {
        return;
      }
    }
    const alertReference = await this.alertController.create({
      header,
      message,
      buttons,
      cssClass: ['custom-alert', customClass],
      backdropDismiss: isBackDropDismiss,
    });

    return await alertReference.present();
  }

  public async presentCustomAlert(header: string, message: string, type: 'Success' | 'Declined' | 'Celeberate', classes = '') {
    const presentModel = await this.modalCtrl.create({
      component: WalletInterrogateSuccessPageComponent,
      componentProps: {
        generalData: { header, message, type },
      },
      showBackdrop: true,
      mode: 'ios',
      cssClass: `payment-success-modal alert-modal base_modal ${classes}`,
    });
    return await presentModel.present();
  }

  public dismissAlert() {
    this.alertController.dismiss();
  }

  public guestCheckoutAlert(): void {
    const signIn = {
      text: 'Sign In',
      cssClass: 'okButton centerButton ion-text-uppercase',
      handler: () => {
        this.navController.navigateRoot(LOGIN);
      },
    };
    const createAccount = {
      text: 'Create Account',
      cssClass: 'okButton centerButton ion-text-uppercase',
      handler: () => {
        this.navController.navigateRoot(SIGNUP);
      },
    };

    const guestCheckout = {
      text: 'Checkout as Guest',
      cssClass: 'okButton centerButton ion-text-uppercase',
      handler: () => {
        this.navController.navigateForward([CHECKOUT_ORDER]);
      },
    };

    this.presentAlert('Attention', 'Please sign in, create account or checkout as a guest.', [guestCheckout, signIn, createAccount], true);
  }

  public loginSignupAlert() {
    const signIn = {
      text: 'Sign In',
      cssClass: 'okButton centerButton',
      handler: () => {
        this.navController.navigateRoot(LOGIN);
      },
    };
    const createAccount = {
      text: 'Create Account',
      cssClass: 'okButton centerButton',
      handler: () => {
        this.navController.navigateRoot(SIGNUP);
      },
    };
    this.presentAlert('Please sign in', 'Please sign in or create an account', [signIn, createAccount], true);
  }
}
